import Penthouse1 from "./penthouse (1).webp";
import Penthouse2 from "./penthouse (2).webp";

const penthouse = [Penthouse1, Penthouse2];

export default penthouse;
